import{jsx as r}from"react/jsx-runtime";import s from"classnames";import t from"./MenuDivider.scss.js";var a=function(a){var e=a.testId,m=a.className;return r("div",{className:s(t.root,m),"data-testid":e})};export{a as MenuDivider};
